module.exports = __webpack_public_path__ + "static/media/29EUNOG13.79f2d8fa.jpg";